<template>
  <DialogComponent
    id="form-modal"
    class="form-modal"
    :visible.sync="visible"
    :fullscreen="true"
    :show-close="false"
    :modal="false"
  >
    <div id="form-modal-header" class="modal-header">
      <div class="modal-header-layout flex grid-6 align-center">
        <h1 class="modal-title col-2">{{ modalTitle }}</h1>
        <div class="modal-actions col-2">
          <el-button
            v-if="activeStep == 1"
            type="primary"
            @click="editStoreInfo"
          >
            Save
          </el-button>

          <el-button
            type="default"
            class="hidden-xs-only"
            @click="cancelOperation"
            >Close
          </el-button>
          <el-button
            type="default"
            icon="el-icon-close"
            class="hidden-sm-and-up"
            @click="cancelOperation"
          />
        </div>
      </div>
    </div>

    <el-form :disabled="processing">
      <el-steps :active="activeStep" finish-status="success">
        <el-step style="cursor: pointer" @click.native="goToStep(0)"></el-step>
        <el-step style="cursor: pointer" @click.native="goToStep(1)"></el-step>
      </el-steps>

      <div v-if="context === 'Edit'" class="button-group mb-20">
        <div class="flex">
          <el-button
            v-if="activeStep > 0"
            icon="el-icon-arrow-left"
            type="default"
            @click="stepBack"
            >{{ stepBackBtnLabel }}
          </el-button>

          <div class="box right">
            <el-button
              v-if="stepForwardBtnLabel"
              type="default"
              @click="stepForward"
              >{{ stepForwardBtnLabel }}
              <i class="el-icon-arrow-right el-icon-right"></i
            ></el-button>
          </div>
        </div>

        <el-button v-if="canStepForward" type="default" @click="stepForward"
          >Store Info <i class="el-icon-arrow-right el-icon-right"></i
        ></el-button>
      </div>

      <div id="step-1" v-if="activeStep == 0" v-loading="processing">
        <div class="inline-form-group">
          <el-col :span="12">
            <el-input v-model="form.name" placeholder="Name">
              <template slot="prefix">Name</template>
            </el-input>
          </el-col>
          <el-col :span="1"></el-col>
          <el-col :span="11">
            <dads-select
              placeholder="Select Caller Id Number"
              v-model="form.callerIdNumber"
              filterable
              clearable
              remote
              :remote-method="remoteSearchCidNums"
            >
              <el-option
                v-for="(item, i) in callerIdNumberOptions"
                :key="i"
                :label="item.label | formatNumber"
                :value="item.label"
              />
              <template slot="prefix">Caller Id Number</template>
            </dads-select>
          </el-col>
        </div>

        <div class="inline-form-group">
          <el-col :span="12">
            <el-input v-model="form.npi" placeholder="NPI">
              <template slot="prefix">NPI</template>
            </el-input>
          </el-col>
          <el-col :span="1"></el-col>
          <el-col :span="11">
            <el-input v-model="form.ncpdp" placeholder="NCPDP">
              <template slot="prefix">NCPDP</template>
            </el-input>
          </el-col>
        </div>

        <div class="inline-form-group">
          <el-col :span="12">
            <dads-select
              v-model="form.branchId"
              :value="form.branchId"
              placeholder="Select branch"
              filterable
            >
              <el-option
                v-for="(item, index) in branchOptions"
                :key="index"
                :label="item.name"
                :value="item.id"
              />
              <template slot="prefix">Branch</template>
            </dads-select>
          </el-col>
          <el-col :span="1"></el-col>
          <el-col :span="11">
            <DadsSelect
              clearable
              filterable
              v-model="form.timezone"
              :value="form.timezone"
              placeholder="Select time zone"
            >
              <template slot="prefix">Time zone</template>
              <el-option
                v-for="(time, index) in timezoneOptions"
                :key="index"
                :label="time.name"
                :value="time.name"
              />
            </DadsSelect>
          </el-col>
        </div>

        <div class="flex mt-30">
          <div class="box right">
            <el-button type="primary" @click="handleSubmit"
              >{{ context }}
            </el-button>
          </div>
        </div>
      </div>

      <div id="step-2" v-show="activeStep == 1" v-loading="processing">
        <h2 class="form-section-header">Store information</h2>
        <el-input
          v-model="storeInfoForm.storeName"
          placeholder="Enter store name"
        >
          <template slot="prefix">Store name</template>
        </el-input>

        <el-input
          v-model="storeInfoForm.website"
          placeholder="Enter website"
        >
          <template slot="prefix">Website</template>
        </el-input>

        <el-input
          v-model="storeInfoForm.contactPhone"
          placeholder="Enter phone contact"
        >
          <template slot="prefix">Phone contact</template>
        </el-input>

        <el-input
          v-model="storeInfoForm.contactEmail"
          placeholder="Enter email contact"
        >
          <template slot="prefix">Email contact</template>
        </el-input>

        <h2 class="form-section-header">Address</h2>
        <el-input
          name="autoAddress"
          v-model="address"
          placeholder="Search for address"
        >
          <template slot="prefix">Search address</template>
        </el-input>

        <div class="address-fields" v-if="addressFieldsActive">
          <div class="inline-form-group">
            <el-col :span="8">
              <el-input
                v-model="addressForm.streetNum"
                placeholder="Enter street number"
              >
                <template slot="prefix">Street number</template>
              </el-input>
            </el-col>
            <el-col :span="1" />
            <el-col :span="15">
              <el-input
                v-model="addressForm.streetInfo"
                placeholder="Enter street name"
              >
                <template slot="prefix">Street Name</template>
              </el-input>
            </el-col>
          </div>
          <div class="inline-form-group">
            <el-col :span="8">
              <el-select
                v-model="addressForm.locationType"
                placeholder="Select location type"
                clearable
              >
                <template slot="prefix">Building / suite</template>
                <el-option
                  v-for="location in locationOptions"
                  :key="location"
                  :label="location"
                  :value="location"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="1" />
            <el-col :span="15">
              <el-input
                v-model="addressForm.locationNumber"
                placeholder="Enter building / suite number"
              >
                <template slot="prefix">Building / suite number</template>
              </el-input>
            </el-col>
          </div>
          <div class="inline-form-group">
            <el-col :span="11">
              <el-input v-model="addressForm.city" placeholder="Enter city">
                <template slot="prefix">City</template>
              </el-input>
            </el-col>
            <el-col :span="1"></el-col>
            <el-col :span="5">
              <el-input
                v-model="addressForm.state"
                placeholder="Enter state"
              >
                <template slot="prefix">State</template>
              </el-input>
            </el-col>
            <el-col :span="1"></el-col>
            <el-col :span="6">
              <el-input
                v-model="addressForm.postalCode"
                placeholder="Enter zip"
              >
                <template slot="prefix">Zip code</template>
              </el-input>
            </el-col>
          </div>
        </div>

        <h2 class="form-section-header">Compliance</h2>
        <div class="compliance-toggle-row">
          <div class="compliance-toggle-label">
            Enforce Call Recording Message in Two-Party States
            <el-tooltip placement="right" effect="dark">
              <div slot="content" style="max-width: 300px">
                When this is on and recording is enabled, callers will hear a short message at the start of inbound and outbound calls letting them know the call is being recorded. This is meant to help meet two-party consent requirements in states where they apply. You will select a voice for the message when enabling this setting.
              </div>
              <i class="el-icon-info" style="margin-left: 6px; cursor: help"></i>
            </el-tooltip>
          </div>
          <el-switch
            :value="storeInfoForm.recordingConsent"
            :active-value="1"
            :inactive-value="0"
            active-color="#35be8b"
            inactive-color="#f25a6b"
            @change="onRecordingConsentChange"
          />
        </div>

        <div
          v-if="storeInfoForm.recordingConsent === 1 && storeInfoForm.recordingMeId"
          class="compliance-current-row"
        >
          <el-tooltip placement="top" content="Preview current recording">
            <el-button
              v-loading="complianceCurrentLoading"
              :icon="complianceCurrentPlaying ? 'mdi mdi-pause' : 'mdi mdi-play'"
              circle
              type="primary"
              size="mini"
              @click="toggleComplianceCurrentAudio"
            />
          </el-tooltip>
          <span class="compliance-current-status">
            {{ complianceCurrentPlaying ? "Playing current recording..." : "Preview current recording" }}
          </span>
          <el-button
            type="text"
            class="compliance-change-voice"
            @click="openComplianceModal"
          >
            Change voice
          </el-button>
          <audio
            ref="complianceCurrentAudio"
            :src="complianceCurrentUrl || ''"
            style="display: none"
            @ended="complianceCurrentPlaying = false"
            @pause="complianceCurrentPlaying = false"
            @play="complianceCurrentPlaying = true"
          />
        </div>
      </div>
    </el-form>

    <!-- Recording Consent Voice Modal -->
    <el-dialog
      title="Select Recording Consent Voice"
      :visible.sync="complianceModalVisible"
      width="500px"
      :before-close="cancelComplianceModal"
      append-to-body
    >
      <p style="color: #606266; font-size: 13px; margin-bottom: 16px;">
        Select a voice for the recording consent message. The following message will be played to callers:
      </p>
      <p style="font-style: italic; color: #909399; font-size: 13px; margin-bottom: 20px;">
        "This call is being recorded for compliance and quality purposes. By staying on the line, you consent to the recording."
      </p>
      <div class="inline-form-group">
        <el-col :span="11">
          <span class="compliance-modal-label">Voice Gender</span>
          <dads-select
            v-model="complianceVoiceGender"
            placeholder="Select voice gender"
            @change="onComplianceGenderChange"
          >
            <el-option label="Masculine" value="male" />
            <el-option label="Feminine" value="female" />
          </dads-select>
        </el-col>
        <el-col :span="1"></el-col>
        <el-col :span="12">
          <span class="compliance-modal-label">Voice</span>
          <dads-select
            v-loading="complianceVoiceFetching"
            v-model="complianceVoiceId"
            placeholder="Select Voice"
            filterable
            @change="onComplianceVoiceChange"
          >
            <el-option
              v-for="(item, i) in complianceVoiceOptions"
              :key="i"
              :label="item.name"
              :value="item.id"
            />
          </dads-select>
        </el-col>
      </div>

      <div class="compliance-preview-row">
        <el-button
          :disabled="!complianceVoiceId || compliancePreviewLoading"
          :loading="compliancePreviewLoading"
          icon="mdi mdi-volume-high"
          @click="previewComplianceVoice"
        >
          Preview
        </el-button>
        <audio
          v-if="compliancePreviewUrl"
          :src="compliancePreviewUrl"
          controls
          class="compliance-preview-audio"
        />
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelComplianceModal">Cancel</el-button>
        <el-button
          type="primary"
          :disabled="!complianceVoiceId"
          :loading="processingConsentAudio"
          @click="saveComplianceVoice"
        >
          Save
        </el-button>
      </span>
    </el-dialog>
  </DialogComponent>
</template>

<script>
import { debounce } from "lodash";
import DadsSelect from "@/components/select";
import { phoneNumberFormatter } from "@/globals/globals";
import DialogComponent from "@/components/CustomModalComponent";
import feathersClient, { apiV2Host } from "@/feathers/feathers-client";

export default {
  name: "UnintegratedLocationForm",

  props: {
    context: { required: true },
    visible: { required: true },
    clearForm: { required: true },
    typeOptions: { required: true },
    selectedAgent: { required: true },
    branchOptions: { required: true }
  },

  components: {
    DadsSelect,
    DialogComponent
  },

  data() {
    return {
      agent: null,
      activeStep: 0,
      processing: false,
      fieldsChanged: false,
      callerIdNumberQuery: "",
      callerIdNumberOptions: [],
      timezoneOptions: [],

      autocomplete: null,
      address: "",
      addressFieldsActive: false,
      locationOptions: ["BLDG", "FL", "STE", "APT"],
      addressForm: {
        streetNum: "",
        streetInfo: "",
        city: "",
        state: "",
        postalCode: "",
        locationType: "",
        locationNumber: ""
      },

      form: {
        tenantId: null,
        name: "",
        npi: "",
        ncpdp: "",
        callerIdNumber: undefined,
        timezone: undefined,
        branchId: null,
        pms: "Location"
      },

      storeInfoForm: {
        storeName: null,
        website: null,
        contactPhone: null,
        contactEmail: null,
        recordingConsent: 0,
        recordingMeId: null,
        pms: "Location"
      },
      complianceModalVisible: false,
      complianceVoiceGender: null,
      complianceVoiceId: null,
      complianceVoiceOptions: [],
      complianceVoiceFetching: false,
      compliancePrefillToken: 0,
      processingConsentAudio: false,
      compliancePreviewUrl: null,
      compliancePreviewLoading: false,
      complianceCurrentUrl: null,
      complianceCurrentLoading: false,
      complianceCurrentPlaying: false
    };
  },

  async created() {
    await this.getDefaultBranch();
  },

  computed: {
    stepForwardBtnLabel() {
      return null;
    },

    stepBackBtnLabel() {
      if (this.activeStep === 1) {
        return "Location Settings";
      }
    },

    selectedTenant() {
      return this.$store.state.selectedTenant;
    },

    modalTitle() {
      if (this.activeStep === 0) {
        return `${
          this.context === "Create" ? this.context : "View / Edit"
        } Location`;
      }

      return `${
        this.context === "Create" ? "Configure" : "View / Configure"
      } Location`;
    },

    canStepForward() {
      return (
        this.activeStep === 0 &&
        (!this.fieldsChanged || this.context === "Edit")
      );
    }
  },

  watch: {
    selectedTenant() {
      this.getCallerIdNumberOptions();
    },

    async visible(visible) {
      if (visible) {
        this.getDefaultBranch();
      }
    },

    clearForm(clear) {
      if (clear) {
        this.clearFields();
      }
    },

    form: {
      deep: true,
      handler: debounce(function determineFieldsChanged(form) {
        if (!this.agent) {
          this.fieldsChanged = false;
        }

        for (let key in this.agent) {
          this.fieldsChanged = key in form && this.agent[key] !== form[key];

          if (this.fieldsChanged) break;
        }
      }, 500)
    },

    selectedAgent(agent) {
      if (agent) {
        this.agent = agent;

        const { address } = agent;

        this.setBranchId(agent.branchId);

        if (address) {
          this.addressFieldsActive = true;

          for (const key in address) {
            if (key in this.addressForm) {
              this.addressForm[key] = address[key];
            }
          }

          if (address.location) {
            const [locationType, locationNumber] =
              address.location.split(" ");
            this.addressForm.locationType = locationType;
            this.addressForm.locationNumber = locationNumber;
          }
        }

        for (let key of Object.keys(agent)) {
          if (key in this.form) {
            this.form[key] = agent[key];
          }

          if (
            key in this.storeInfoForm &&
            agent[key] !== undefined &&
            agent[key] !== null
          ) {
            this.storeInfoForm[key] = agent[key];
          }
        }
      }
    },

    callerIdNumberQuery: {
      handler: debounce(function searchCidNums() {
        this.getCallerIdNumberOptions();
      }, 500)
    }
  },

  methods: {
    stepBack() {
      this.activeStep--;
    },

    stepForward() {
      this.activeStep++;
    },

    goToStep(step) {
      if (
        this.activeStep === step ||
        this.context === "Create" ||
        this.processing
      )
        return;
      this.activeStep = step;
    },

    remoteSearchCidNums(query) {
      this.callerIdNumberQuery = query;
    },

    getCallerIdNumberOptions() {
      const didParams = {
        query: {
          tenantId: this.selectedTenant.id,
          allowEmergency: "",
          $limit: 10
        }
      };

      if (this.callerIdNumberQuery && this.callerIdNumberQuery.length) {
        didParams.query.$or = [
          { number: { $like: `%${this.callerIdNumberQuery}%` } }
        ];
      }

      feathersClient
        .service("dids")
        .find(didParams)
        .then((res) => {
          this.callerIdNumberOptions = [];
          this.callerIdNumberOptions = res.map((item) => ({
            key: item.id,
            label: item.number
          }));
        });
    },

    async setBranchId(branchId) {
      if (branchId && branchId !== 0) {
        this.form.branchId = branchId;
        return;
      }
      try {
        const res = await feathersClient.service("branches").find({
          query: {
            tenantId: this.selectedTenant.id,
            default: 1
          }
        });
        const [defaultBranch] = res;
        if (defaultBranch) {
          this.form.branchId = defaultBranch.id;
        }
      } catch (err) {
        console.error("Failed to fetch default branch", err);
        this.form.branchId = null;
      }
    },

    handleSubmit() {
      if (this.context === "Create") {
        this.createOperation();
        return;
      }

      this.editOperation();
    },

    buildAddress() {
      const {
        streetNum,
        streetInfo,
        city,
        state,
        postalCode,
        locationType,
        locationNumber
      } = this.addressForm;

      const address = {
        streetNum,
        streetInfo,
        location: "",
        city,
        state,
        postalCode
      };

      if (locationType && locationNumber) {
        address.location = `${locationType} ${locationNumber}`;
      }

      return address;
    },

    setupFormForAgentType() {
      let form = { ...this.form };

      if (this.context !== "Create") delete form.tenantId;

      if (!form.callerIdNumber) delete form.callerIdNumber;

      return form;
    },

    createOperation() {
      this.form.tenantId = this.selectedTenant.id;

      const createBody = this.setupFormForAgentType();

      this.$confirm(`Create Location?`, "Warning", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning"
      })
        .then(async () => {
          this.processing = true;
          try {
            const res = await fetch(`${apiV2Host}/admin/pharmacy/agents`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${this.$store.state.auth.accessToken}`,
                Accept: "application/json"
              },
              body: JSON.stringify(createBody)
            });

            this.processing = false;
            const response = await res.json();

            if (!res.ok) {
              const { name, message, validationErrors } = response;
              this.$notify({
                title: name,
                message:
                  validationErrors && validationErrors.length
                    ? validationErrors[0]
                    : message,
                type: "error"
              });

              return;
            }

            this.agent = response;

            this.activeStep += 1;

            this.$notify({
              type: "success",
              title: "Success",
              message: "Created successfully"
            });
          } catch (err) {
            this.processing = false;
          }
        })
        .catch(() => true);
    },

    async patchAgent(body) {
      return fetch(`${apiV2Host}/admin/pharmacy/agents/${this.agent.id}`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.auth.accessToken}`,
          Accept: "application/json"
        },
        body: JSON.stringify(body)
      });
    },

    editOperation() {
      this.$confirm(`Edit Location?`, "Warning", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning"
      })
        .then(async () => {
          try {
            this.processing = true;

            const editBody = this.setupFormForAgentType();

            const res = await this.patchAgent(editBody);
            const response = await res.json();

            this.processing = false;

            if (!res.ok) {
              const { name, message, validationErrors } = response;
              this.$notify({
                title: name,
                message:
                  validationErrors && validationErrors.length
                    ? validationErrors[0]
                    : message,
                type: "error"
              });
              return;
            }

            this.activeStep++;
            this.fieldsChanged = false;
            this.agent = response;

            this.$notify({
              type: "success",
              title: "Success",
              message: "Edited successfully"
            });
          } catch (err) {
            console.dir(err);
            this.processing = false;
          }
        })
        .catch(() => true);
    },

    editStoreInfo() {
      this.$confirm(
        `Save Location store information?`,
        "Warning",
        {
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          type: "warning"
        }
      )
        .then(async () => {
          try {
            const configBody = { ...this.storeInfoForm };

            if (this.addressFieldsActive) {
              configBody.address = this.buildAddress();
            }

            this.processing = true;

            const res = await this.patchAgent(configBody);
            const response = await res.json();

            if (!res.ok) {
              this.processing = false;
              const { name, message, validationErrors } = response;
              this.$notify({
                title: name,
                message:
                  validationErrors && validationErrors.length
                    ? validationErrors[0]
                    : message,
                type: "error"
              });
              return;
            }

            this.agent = response;
            this.processing = false;
            this.cancelOperation();

            this.$notify({
              type: "success",
              title: "Success",
              message: `Location configured successfully`
            });
          } catch (err) {
            console.dir({ err });
            this.processing = false;
          }
        })
        .catch(() => true);
    },

    cancelOperation() {
      this.activeStep = 0;
      this.$emit("cancelOperation", this.agent);
    },

    clearFields() {
      this.agent = null;
      this.activeStep = 0;
      this.fieldsChanged = false;
      this.callerIdNumberQuery = "";

      this.addressFieldsActive = false;
      this.address = "";
      this.addressForm = {
        streetNum: "",
        streetInfo: "",
        city: "",
        state: "",
        postalCode: "",
        locationType: "",
        locationNumber: ""
      };

      this.form = {
        tenantId: null,
        name: "",
        npi: "",
        ncpdp: "",
        callerIdNumber: undefined,
        timezone: undefined,
        branchId: null,
        pms: "Location"
      };
      this.getDefaultBranch();

      this.storeInfoForm = {
        storeName: null,
        website: null,
        contactPhone: null,
        contactEmail: null,
        recordingConsent: 0,
        recordingMeId: null,
        pms: "Location"
      };

      this.complianceModalVisible = false;
      this.complianceVoiceGender = null;
      this.complianceVoiceId = null;
      this.complianceVoiceOptions = [];
      this.revokeCompliancePreview();
      this.complianceCurrentUrl = null;
      this.complianceCurrentPlaying = false;
    },

    queryTimezoneOptions() {
      feathersClient
        .service("timezones")
        .find({
          query: {
            $sort: { name: 1 }
          }
        })
        .then((res) => {
          this.timezoneOptions = res;
        });
    },

    async getDefaultBranch() {
      try {
        if (!this.form.branchId) {
          const res = await feathersClient.service("branches").find({
            query: {
              tenantId: this.selectedTenant.id,
              default: 1
            }
          });

          const [defaultBranch] = res;
          if (defaultBranch) {
            this.form.branchId = defaultBranch.id;
          }
        }
      } catch (err) {
        console.error("Failed to fetch default branch", err);
      }
    },

    onRecordingConsentChange(val) {
      if (val === 1) {
        this.openComplianceModal();
      } else {
        this.storeInfoForm.recordingConsent = 0;
        this.storeInfoForm.recordingMeId = null;
        this.complianceCurrentUrl = null;
        this.complianceCurrentPlaying = false;
      }
    },

    openComplianceModal() {
      this.complianceVoiceId = null;
      this.complianceVoiceOptions = [];
      this.complianceVoiceGender = null;
      this.revokeCompliancePreview();
      this.complianceModalVisible = true;
      this.prefillComplianceVoice();
    },

    // Prefer the voice the saved consent recording was generated with, and
    // fall back to the location's configured default voice
    // (pil.default_voice_id). Auto-selected, but still editable.
    async prefillComplianceVoice() {
      const token = ++this.compliancePrefillToken;
      const isStale = () =>
        token !== this.compliancePrefillToken || !this.complianceModalVisible;
      this.complianceVoiceFetching = true;
      try {
        const preset =
          (await this.resolveSavedComplianceVoice()) ||
          this.defaultComplianceVoice();
        if (isStale() || !preset) return;
        this.complianceVoiceGender = preset.gender;
        await this.queryComplianceVoiceOptions();
        if (isStale()) return;
        // queryComplianceVoiceOptions resets complianceVoiceId; re-apply the
        // preset only if it exists in the fetched catalog list.
        const match = this.complianceVoiceOptions.find(
          (v) => String(v.id) === String(preset.id)
        );
        if (match) {
          this.complianceVoiceId = match.id;
        }
      } finally {
        if (token === this.compliancePrefillToken) {
          this.complianceVoiceFetching = false;
        }
      }
    },

    defaultComplianceVoice() {
      if (
        !this.agent ||
        !this.agent.defaultVoiceGender ||
        this.agent.defaultVoiceId == null
      ) {
        return null;
      }
      return { gender: this.agent.defaultVoiceGender, id: this.agent.defaultVoiceId };
    },

    // Looks up the catalog voice stored on the saved consent media file.
    // Returns null when there is no recording or its voice can't be resolved.
    async resolveSavedComplianceVoice() {
      const meId = this.ivaConfigForm.recordingMeId;
      if (!meId) return null;
      const headers = { Authorization: `Bearer ${this.$store.state.auth.accessToken}` };
      try {
        const fileRes = await fetch(`${apiV2Host}/admin/media-files/${meId}`, {
          method: "GET",
          headers
        });
        if (!fileRes.ok) return null;
        const file = await fileRes.json();
        if (file && file.mediaUrl && !this.complianceCurrentUrl) {
          this.complianceCurrentUrl = file.mediaUrl;
        }
        if (!file || !file.voiceId) return null;
        const voicesRes = await fetch(`${apiV2Host}/text-to-speech/voices`, {
          method: "GET",
          headers
        });
        if (!voicesRes.ok) return null;
        const { voices } = await voicesRes.json();
        const match = (voices || []).find(
          (v) => String(v.id) === String(file.voiceId)
        );
        return match ? { gender: match.gender, id: match.id } : null;
      } catch (e) {
        console.error(e);
        return null;
      }
    },

    onComplianceGenderChange() {
      // A manual gender change supersedes any in-flight prefill.
      this.compliancePrefillToken++;
      this.queryComplianceVoiceOptions();
    },

    onComplianceVoiceChange() {
      this.revokeCompliancePreview();
    },

    revokeCompliancePreview() {
      if (this.compliancePreviewUrl) {
        URL.revokeObjectURL(this.compliancePreviewUrl);
        this.compliancePreviewUrl = null;
      }
    },

    async previewComplianceVoice() {
      if (!this.complianceVoiceId) return;
      this.compliancePreviewLoading = true;
      try {
        this.revokeCompliancePreview();
        const res = await fetch(
          `${apiV2Host}/text-to-speech/voices/${this.complianceVoiceId}/tts`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.$store.state.auth.accessToken}`,
              Accept: "application/json"
            },
            body: JSON.stringify({
              text: "This call is being recorded for compliance and quality purposes. By staying on the line, you consent to the recording."
            })
          }
        );
        if (!res.ok) {
          const data = await res.json().catch(() => ({}));
          this.$notify({
            title: data.name || "Preview Failed",
            message: data.message || "Could not generate preview",
            type: "error"
          });
          return;
        }
        const blob = await res.blob();
        this.compliancePreviewUrl = URL.createObjectURL(blob);
      } catch (e) {
        console.error(e);
        this.$notify({ title: "Preview Failed", message: "Could not generate preview", type: "error" });
      } finally {
        this.compliancePreviewLoading = false;
      }
    },

    async ensureComplianceCurrentUrl() {
      if (this.complianceCurrentUrl || !this.storeInfoForm.recordingMeId) return;
      this.complianceCurrentLoading = true;
      try {
        const res = await fetch(
          `${apiV2Host}/admin/media-files/${this.storeInfoForm.recordingMeId}`,
          {
            method: "GET",
            headers: { Authorization: `Bearer ${this.$store.state.auth.accessToken}` }
          }
        );
        if (!res.ok) return;
        const file = await res.json();
        this.complianceCurrentUrl = file && file.mediaUrl ? file.mediaUrl : null;
      } catch (e) {
        console.error(e);
      } finally {
        this.complianceCurrentLoading = false;
      }
    },

    async toggleComplianceCurrentAudio() {
      const el = this.$refs.complianceCurrentAudio;
      if (this.complianceCurrentPlaying && el) {
        el.pause();
        return;
      }
      if (!this.complianceCurrentUrl) {
        await this.ensureComplianceCurrentUrl();
      }
      if (!this.complianceCurrentUrl) return;
      await this.$nextTick();
      try {
        if (this.$refs.complianceCurrentAudio) {
          await this.$refs.complianceCurrentAudio.play();
        }
      } catch (e) {
        console.error(e);
      }
    },

    async queryComplianceVoiceOptions() {
      this.complianceVoiceId = null;
      this.revokeCompliancePreview();
      const url = `${apiV2Host}/text-to-speech/voices?gender=${this.complianceVoiceGender}`;
      try {
        this.complianceVoiceFetching = true;
        this.complianceVoiceOptions = [];
        const response = await fetch(url, {
          method: "GET",
          headers: { Authorization: "Bearer " + this.$store.state.auth.accessToken }
        });
        this.complianceVoiceFetching = false;
        if (!response.ok) return;
        // New provider-agnostic catalog: { voices: [{ id, label, persona, gender }] }.
        // Map to the shape the compliance select expects (value=id, label=name).
        const { voices } = await response.json();
        this.complianceVoiceOptions = (voices || []).map((voice) => ({
          id: voice.id,
          name: voice.label,
          description: voice.persona,
          gender: voice.gender
        }));
      } catch (e) {
        this.complianceVoiceFetching = false;
        console.error(e);
      }
    },

    async saveComplianceVoice() {
      try {
        this.processingConsentAudio = true;
        const res = await fetch(`${apiV2Host}/admin/pharmacy/agents/${this.agent.id}/consent-audio`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.$store.state.auth.accessToken}`
          },
          body: JSON.stringify({ voice: this.complianceVoiceId })
        });
        if (!res.ok) {
          const data = await res.json();
          this.$notify({ title: data.name || "Error", message: data.message, type: "error" });
          this.processingConsentAudio = false;
          return;
        }
        const { id } = await res.json();
        this.storeInfoForm.recordingMeId = id;
        this.storeInfoForm.recordingConsent = 1;
        this.complianceCurrentUrl = null;
        this.complianceCurrentPlaying = false;
        this.revokeCompliancePreview();
        this.processingConsentAudio = false;
        this.complianceModalVisible = false;
        this.$notify({ type: "success", title: "Success", message: "Recording consent voice saved" });
      } catch (e) {
        this.processingConsentAudio = false;
        console.error(e);
      }
    },

    cancelComplianceModal() {
      this.complianceModalVisible = false;
      this.complianceVoiceGender = null;
      this.complianceVoiceId = null;
      this.complianceVoiceOptions = [];
      this.revokeCompliancePreview();
    },

    populateAddressFields(obj) {
      this.addressForm.streetNum = obj["street_number"];
      this.addressForm.streetInfo = obj["route"];
      this.addressForm.city = obj["locality"];
      this.addressForm.state = obj["administrative_area_level_1"];
      this.addressForm.postalCode = obj["postal_code"];
      this.addressForm.locationType = "";
      this.addressForm.locationNumber = "";

      this.address =
        obj["street_number"] +
        " " +
        obj["route"] +
        " " +
        obj["locality"] +
        ", " +
        obj["administrative_area_level_1"] +
        " " +
        obj["postal_code"];
    }
  },

  filters: {
    formatNumber(value) {
      return phoneNumberFormatter(value);
    }
  },

  mounted() {
    this.queryTimezoneOptions();
    this.getCallerIdNumberOptions();

    const locationInfo = {
      street_number: "short_name",
      route: "long_name",
      locality: "long_name",
      administrative_area_level_1: "short_name",
      postal_code: "short_name"
    };

    this.autocomplete = new google.maps.places.Autocomplete(
      document.querySelector("input[name='autoAddress']")
    );

    this.autocomplete.setFields(["address_components", "geometry"]);
    this.autocomplete.setComponentRestrictions({
      country: ["us"]
    });

    this.autocomplete.addListener("place_changed", () => {
      const place = this.autocomplete.getPlace();
      const ac = place.address_components;

      const locationObject = {
        street_number: "",
        route: "",
        locality: "",
        administrative_area_level_1: "",
        postal_code: ""
      };

      for (let i = 0; i < ac.length; i++) {
        let addressType = ac[i].types[0];
        if (locationInfo[addressType]) {
          locationObject[addressType] = ac[i][locationInfo[addressType]];
        }
      }

      this.populateAddressFields(locationObject);
      this.addressFieldsActive = true;
    });
  }
};
</script>

<style lang="scss" scoped>
.el-steps {
  width: 150px;
  margin: auto;
  margin-bottom: 30px;
}

.el-form {
  max-width: 600px;
  margin: 20px auto 0 auto;

  h4 {
    margin: 12px 0 0 3px;
  }
}

.compliance-toggle-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
  border-bottom: 1px solid #dcdfe6;
}

.compliance-toggle-label {
  font-size: 14px;
  color: #606266;
}

.compliance-modal-label {
  display: block;
  font-size: 12px;
  color: #909399;
  margin-bottom: 4px;
}

.compliance-current-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 16px;
  padding: 12px;
  border: 1px solid #dcdfe6;
  border-radius: 6px;
}

.compliance-current-status {
  flex: 1;
  font-size: 13px;
  color: #606266;
}

.compliance-change-voice {
  margin-left: auto;
}

.compliance-preview-row {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 16px;
}

.compliance-preview-audio {
  width: 100%;
}

body.theme-dark {
  .compliance-toggle-row {
    border-bottom-color: #30363d;
  }

  .compliance-toggle-label {
    color: #c9d1d9;
  }

  .compliance-current-row {
    border-color: #30363d;
  }

  .compliance-current-status {
    color: #c9d1d9;
  }

  .compliance-preview-audio {
    color-scheme: dark;
    border-radius: 999px;
  }
}
</style>
